import Input from "@/ui/input";
import { IconComponent } from "@/ui/icon";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import { WalletType } from "@/providers/wallet";
import WalletsFiltersModal from "@/features/filters-modals/wallets-filters-modal";
import { SectionHeaderToggleButton } from "@/ui/SectionHeaderToggleButton";
import { useWalletDiscoveryFilter } from "@providers/wallet-discovery-filter/wallet-discovery-filter-provider.tsx";
import { useState } from "react";
import clsx from "clsx";
import { UnstyledButton } from "@mantine/core";
import WalletsAdminControls from "../wallet-discovery/wallets-admin-controls";
import { useLocation } from "react-router";

type timeframe = "1w" | "1M" | "1M" | "1y" | "All";

const WalletScreenerHeader = () => {
  const [isStarred, setIsStarred] = useState(false);
  const [activeTimeframe, setActiveTimeframe] = useState<timeframe>("1M");
  const { pathname } = useLocation();
  const isAdmin = pathname.includes("/admin");

  const {
    onTimeFrameUpdate,
    searchWallet,
    onSearchWalletUpdate,
    chains,
    onChainsUpdate,
    showStarred,
    setShowStarred,
  } = useWalletDiscoveryFilter();

  // const handleEthereumClick = () => {
  //   onChainsUpdate((prev: WalletType[]) => {
  //     return prev.includes(WalletType.ETH)
  //       ? prev.filter((c) => c !== WalletType.ETH)
  //       : [...prev, WalletType.ETH];
  //   });
  // };

  const handleSolanaClick = () => {
    onChainsUpdate((prev: WalletType[]) => {
      return prev.includes(WalletType.SOL)
        ? prev.filter((c) => c !== WalletType.SOL)
        : [...prev, WalletType.SOL];
    });
  };

  const handleStarClick = () => {
    setShowStarred(!showStarred);
    setIsStarred((prev) => !prev);
  };

  return (
    <div className="relative w-full flex justify-between items-center px-[0.625rem]">
      <div className="flex justify-center items-center gap-[0.3125rem]">
        <div className="flex justify-center items-center gap-[0.3125rem]">
          {/* <GradientBorderRadius hover="r-100" radius="circle" gradient="none">
            <UnstyledButton
              onClick={handleEthereumClick}
              className={clsx(
                "w-[1.3750rem] h-[1.3750rem] flex justify-center items-center hover:opacity-100",
                chains.includes(WalletType.ETH) ? "opacity-100" : "opacity-50",
              )}
            >
              <IconComponent name="ethereum" className="h-full w-full" />
            </UnstyledButton>
          </GradientBorderRadius> */}
          <GradientBorderRadius hover="none" radius="circle" gradient="none">
            <UnstyledButton
              disabled
              onClick={handleSolanaClick}
              className={clsx(
                "w-[1.3750rem] h-[1.3750rem] flex justify-center items-center hover:opacity-100",
                chains.includes(WalletType.SOL) ? "opacity-100" : "opacity-50",
              )}
            >
              <IconComponent
                name="solanaLogo"
                className="h-full w-full cursor-default"
              />
            </UnstyledButton>
          </GradientBorderRadius>
          <GradientBorderRadius
            hover="r-100"
            radius="circle"
            gradient="none"
            background="black"
          >
            <UnstyledButton
              onClick={handleStarClick}
              className={clsx(
                "w-[1.3750rem] h-[1.3750rem] flex justify-center items-center hover:opacity-100",
                "opacity-100",
              )}
            >
              <IconComponent
                name="starEmpty"
                className="w-[1rem] h-[1rem]"
                fill={isStarred ? "white" : "none"}
              />
            </UnstyledButton>
          </GradientBorderRadius>
        </div>
        <div className="flex justify-center items-center gap-[0.3125rem]">
          <div className="h-full group flex justify-center items-center">
            <div className="h-full w-full flex justify-center items-center">
              <SectionHeaderToggleButton
                className="w-[1.3750rem] h-[1rem]"
                title="1M"
                active={activeTimeframe === "1M"}
                onClick={() => {
                  setActiveTimeframe("1M");
                  onTimeFrameUpdate(5);
                }}
              />
            </div>
          </div>

          <div className="h-[1.45rem] w-[25rem] group">
            <Input
              className="font-semibold group placeholder:text-white"
              placeholder="Wallet"
              defaultValue={searchWallet ?? ""}
              onChange={(value) => onSearchWalletUpdate(value)}
              rightSide={
                <GradientBorderRadius
                  radius="left"
                  gradient="input-50"
                  hover="input-50"
                  className="w-[1.375rem] h-full flex justify-center items-center"
                >
                  <IconComponent
                    name="search"
                    className="w-[0.75rem] h-[0.75rem]"
                  />
                </GradientBorderRadius>
              }
            />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        <div className="text-base leading-[0.625rem] font-semibold">
          Wallet Discovery
        </div>
      </div>
      <div className="flex justify-center items-center gap-[0.3125rem]">
        {isAdmin && <WalletsAdminControls />}
        <WalletsFiltersModal />
      </div>
    </div>
  );
};

export default WalletScreenerHeader;
